(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("core-polyfill-loading", [], factory);
	else if(typeof exports === 'object')
		exports["core-polyfill-loading"] = factory();
	else
		root["core-polyfill-loading"] = factory();
})(self, function() {
return 